import { Injectable, Injector, Compiler, Inject, NgModuleFactory, Type, ViewContainerRef } from '@angular/core';
import { INDEX_SECTION_WIDGETS } from './index-section-tokens';
import { SECTION_DATA } from './section-data';
import { Section } from '../../template-generator/entity/section';
import { AbstractIndexSection } from '../abstract-index-section';

@Injectable()
export class IndexSectionLoaderService {

  constructor(
    private injector: Injector,
    private compiler: Compiler,
    @Inject(INDEX_SECTION_WIDGETS) private indexSectionWidgets: { [key: string]: () => Promise<NgModuleFactory<any> | Type<any>> }
  ) { }

  async load(name: string, container: ViewContainerRef, section: Section) {
    const indexSectionWidget = this.indexSectionWidgets[name] ? this.indexSectionWidgets[name] : this.indexSectionWidgets['index-default'];
    const tempModule = await indexSectionWidget();

    let moduleFactory;

    if (tempModule instanceof NgModuleFactory) {
      // For AOT
      moduleFactory = tempModule;
    } else {
      // For JIT
      moduleFactory = await this.compiler.compileModuleAsync(tempModule);
    }

    const sectionInjector = Injector.create({providers: [
      {provide: SECTION_DATA, useValue: section, multi: false}
    ], parent: this.injector, name: 'section injector'});

    const entryComponent = (moduleFactory.moduleType as any).entry;
    const moduleRef = moduleFactory.create(sectionInjector);

    const compFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(entryComponent);

    return container.createComponent<AbstractIndexSection<any>>(compFactory);
  }
}
